import { render, staticRenderFns } from "./Elegibilidade.vue?vue&type=template&id=66959108"
import script from "./Elegibilidade.vue?vue&type=script&lang=js"
export * from "./Elegibilidade.vue?vue&type=script&lang=js"
import style0 from "./Elegibilidade.vue?vue&type=style&index=0&id=66959108&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports